import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

// 英文环境下隐藏报告导出路由。
// 注意：不能在此处按模块导入时的 locale 静态决定是否导出——路由模块由
// import.meta.globEager 在应用启动时(登录前)加载求值，而英文 locale 可能是登录后才由后端
// 语言偏好(userInfo.currentLanguage)切换过来(例如无痕模式首次登录、本地无缓存)，此时该值
// 仍是默认中文，模块一旦被导出整个 SPA 会话都不会移除，导致英文首登仍显示报告导出。
// 故这里始终导出路由，并在 meta.hideInEn 声明，由 permissionStore.buildRoutesAction
// 在路由构建时按当时的 locale 运行时过滤(此时登录后的 changeLocale 已生效)。
const report: AppRouteModule = {
  path: '/',
  name: '',
  component: LAYOUT,
  redirect: '/report',
  meta: {
    orderNo: 4,
    icon: 'file-export|svg',
    title: t('routes.nurse.report'),
    hideChildrenInMenu: true,
    // 英文环境下隐藏该路由模块(侧边菜单与路由注册均移除)
    hideInEn: true,
  },
  children: [
    {
      path: 'report',
      name: 'Report',
      component: () => import('/@/views/nurse/report/index.vue'),
      meta: {
        icon: 'file-export|svg',
        title: t('routes.nurse.report'),
      },
    },
  ],
};

export default report;
